export const WELCOME_TITLE = 'Welcome to Projects'

export const WELCOME_DESCRIPTION =
  'Built to be flexible and adaptable, Projects gives you a live canvas to filter, sort, and group issues and pull requests in a table, board, or roadmap. Tailor them to your needs with custom fields, saved views, workflows, and insights.'

export const PROJECTS_DOCS_URL =
  'https://docs.github.com/issues/planning-and-tracking-with-projects/learning-about-projects/about-projects'
